import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import {
  Button,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Avatar,
  Tooltip,
} from '@fluentui/react-components';
import {
  PersonRegular,
  SignOutRegular,
  QuestionCircleRegular,
  WeatherSunnyRegular,
  WeatherMoonRegular,
} from '@fluentui/react-icons';
import WikiDrawer from '../WikiDrawer';
import NotificationBell from '../NotificationBell';
import FeedbackMenu from './FeedbackMenu';
import LanguageToggle from './LanguageToggle';
import { useThemeMode } from '../../theme/themeMode';

export default function AppHeader() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [wikiOpen, setWikiOpen] = useState(false);
  const { mode, toggleMode } = useThemeMode();
  const nextModeLabel = mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <header className="app-header">
      <h1>PTC Tax Lifecycle Management</h1>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <NotificationBell />

        <FeedbackMenu />

        <LanguageToggle />

        <Tooltip content={nextModeLabel} relationship="label">
          <Button
            appearance="transparent"
            icon={mode === 'dark' ? <WeatherSunnyRegular /> : <WeatherMoonRegular />}
            onClick={toggleMode}
            style={{ color: 'var(--tl-header-fg)' }}
          />
        </Tooltip>

        <Tooltip content="Help & Documentation" relationship="label">
          <Button
            appearance="transparent"
            icon={<QuestionCircleRegular />}
            onClick={() => setWikiOpen(true)}
            style={{ color: 'var(--tl-header-fg)' }}
          />
        </Tooltip>

        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button
              appearance="transparent"
              icon={
                <Avatar
                  name={account?.name || 'User'}
                  size={28}
                  color="colorful"
                />
              }
              style={{ color: 'var(--tl-header-fg)' }}
            >
              {account?.name || 'User'}
            </Button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem icon={<PersonRegular />}>
                {account?.username}
              </MenuItem>
              <MenuItem icon={<SignOutRegular />} onClick={handleLogout}>
                Sign out
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>

      <WikiDrawer open={wikiOpen} onOpenChange={setWikiOpen} />
    </header>
  );
}
